import * as React from 'react';
export const arrowLeftCircleSvg = React.forwardRef(
  function arrowLeftCircleSvgInner(props, ref) {
    return /*#__PURE__*/ React.createElement(
      'svg',
      {
        ...props,
        ref: ref,
      },
      /*#__PURE__*/ React.createElement('path', {
        d: 'M7.47 3.47a.75.75 0 0 1 1.06 1.06L5.81 7.25H12a.75.75 0 0 1 0 1.5H5.81l2.72 2.72a.75.75 0 1 1-1.06 1.06l-4-4a.75.75 0 0 1 0-1.06l4-4Z',
      }),
      /*#__PURE__*/ React.createElement('path', {
        fillRule: 'evenodd',
        clipRule: 'evenodd',
        d: 'M0 8a8 8 0 0 0 8 8 8 8 0 0 0 8-8 8 8 0 0 0-8-8C3.57 0 0 3.581 0 8Zm1.5 0A6.5 6.5 0 0 0 8 14.5 6.5 6.5 0 0 0 14.5 8 6.5 6.5 0 0 0 8 1.5C4.4 1.5 1.5 4.408 1.5 8Z',
      }),
    );
  },
);
arrowLeftCircleSvg.defaultProps = {
  width: '16',
  height: '16',
  viewBox: '0 0 16 16',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg',
};
export var arrowLeftCircle = {
  category: 'icon',
  colorable: true,
  name: 'arrowLeftCircle',
  svg: arrowLeftCircleSvg,
};
